import { UserInteraction } from '@naf/user-interaction';
import React from 'react';
import { useLocation } from 'react-router';
import { AvailabilityInfo } from '../../../../../types/EventType';
import useSelector from '../../../redux/typedHooks';
import { useLoginRedirect } from '../../../hooks/useLoginRedirect';

type Props = {
  availabilityInfo: AvailabilityInfo;
  organizer: { title: string; type: string };
  className?: string;
};

const AvailabilityInfoBox = ({ availabilityInfo, organizer, className }: Props) => {
  const location = useLocation();
  const { redirectToLoginPage } = useLoginRedirect();
  const clubName = useSelector((state) => state.myMembership.customerInformation.data.membership?.localClub?.clubName);

  if (availabilityInfo === AvailabilityInfo.UserNotLoggedIn) {
    return (
      <UserInteraction
        variant="info"
        title={`Kun for medlemmer av ${organizer.title}`}
        buttonLink={{
          text: 'Logg inn',
          onClick: () => {
            redirectToLoginPage(`${window.location.origin}${location.pathname}`);
            return false; // wrong type in UserInteraction?
          },
        }}
        className={className}
      >
        Dette arrangementet er kun for medlemmer av en spesefikk lokalavdeling. For å se hvilken lokalavdeling du hører
        til, må du logge inn.
      </UserInteraction>
    );
  }
  if (
    availabilityInfo === AvailabilityInfo.UserNotInLocalDepartment ||
    availabilityInfo === AvailabilityInfo.UserNotInMcClub
  ) {
    return (
      <UserInteraction
        variant="info"
        className={className}
      >{`Dette arrangementet er kun for medlemmer av ${organizer.title}. Du er medlem av ${clubName}`}</UserInteraction>
    );
  }
  return null;
};

export default AvailabilityInfoBox;
